import { getAllCompanies } from 'api/services/CompaniesService';
import { UserStateContextType } from 'components/constants/Constants';
import { useUserState } from 'context/User';
import { useEffect, useState } from 'react';

export const useUserBelongsToCompanies = (companiesKeys: string[]) => {
  const userState = useUserState();
  const [belongsToCompany, setBelongsToCompany] = useState<boolean>(false);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    userState.type === UserStateContextType.AUTHENTICATED &&
      getAllCompanies(
        (res: any) => {
          setLoading(false);
          setBelongsToCompany(res.data.content.length > 0);
        },
        () => {},
        companiesKeys
      );
  }, [companiesKeys, userState.type]);
  return { belongsToCompany, loading };
};
